import {Location} from "./location";
import {Subcategory} from "./subcategory";

export class ProductSingle {
  constructor() {}
  itemId: any = '';
  name: any = '';
  photo: any = '';
  like: any = '';
  locationByLocationId: Location = new Location();
  subCategoryBySubId: Subcategory = new Subcategory();
}
​
